<template>
  <div
    class="page-tabs-box"
    v-if="
      !notShowTabsPath.includes($route.path) && !$store.state.pageScroll.scroll
    "
  >
    <div
      class="updateTime"
      v-if="
        $route.matched[0].meta.title == '信息概览' &&
        $store.state.isHasIndexPermissions
      "
    >
      {{ $l("最后更新时间：") }}{{ $store.state.trapLastUpdateTime }}
    </div>
    <el-tabs
      v-model="currentTabsValue"
      @tab-remove="removeTab"
      @tab-click="changeTab"
      type="card"
    >
      <el-tab-pane
        :closable="isDelete && item.path != '/index'"
        v-for="item in routerTabs"
        :key="item.path"
        :label="$l(item.name)"
        :name="item.path"
      >
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "PageTabs",
  data() {
    return {
      routerTabs: [],
      currentTabsValue: null,
      notWithoutTabsPath: [
        "/indexBigScreen/indexBigScreen",
        "/deviceBigScreen/deviceBigScreen",
        "/report/elevatorDaily",
        "/report/weekly",
        "/report/monthly",
        "/report/daily",
        "/report/domainWeekly",
        "/report/domainMonthly",
      ],
      notShowTabsPath: [
        "/indexBigScreen/indexBigScreen",
        "/report/elevatorDaily",
        "/report/weekly",
        "/report/monthly",
        "/report/daily",
        "/report/domainWeekly",
        "/report/domainMonthly",
      ],
    };
  },
  computed: {
    isDelete() {
      return this.routerTabs.length != 1;
    },
  },
  created() {
    this.initPageTabs();
  },
  methods: {
    initPageTabs() {
      const his = sessionStorage.getItem("routerTabList");
      if (his) {
        this.$store.commit("setRouterTabList", JSON.parse(his));
      }
      const existIndex = this.$store.state.routerTabList.findIndex(
        (v) => v.path == this.$route.path
      );
      const query = JSON.stringify(this.$route.query);
      this.routerTabs = this.$store.state.routerTabList;
      if (this.notWithoutTabsPath.includes(this.$route.path)) return false;
      this.currentTabsValue = this.$route.path;
      if (existIndex == -1) {
        if (!this.$store.state.pageScroll.scroll) {
          this.routerTabs.push({
            name: this.$route.meta.title || this.$route.matched[0].meta.title,
            path: this.$route.path,
            query: this.$route.query,
            keepAliveName: this.$parent.$parent.$parent.$parent.$options.name,
          });
        }
      } else if (query != JSON.stringify(this.routerTabs[existIndex].query)) {
        this.routerTabs[existIndex].query = JSON.parse(query);
        const path = this.$route.path;
        const que = JSON.parse(query);
        this.removeTab(this.$route.path);
        this.$nextTick(() => {
          this.$router.push({ path, query: que });
        });
      }
      this.$store.commit("setRouterTabList", this.routerTabs);
    },
    removeTab(path) {
      const deleteIndex = this.$store.state.routerTabList.findIndex(
        (v) => v.path == path
      );
      this.routerTabs.splice(deleteIndex, 1);
      this.$store.commit("setRouterTabList", this.routerTabs);
      if (path != this.$route.path) return;
      if (deleteIndex - 1 >= 0) {
        this.$router.push(this.routerTabs[deleteIndex - 1].path);
      } else {
        this.$router.push(this.routerTabs[deleteIndex].path);
      }
    },
    changeTab(e) {
      const query = this.routerTabs[e.index].query;
      if (this.$route.path != e.name) {
        this.$router.push({ path: e.name, query });
      }
    },
  },
  activated() {
    this.initPageTabs();
  },
};
</script>

<style lang="scss" scoped>
.page-tabs-box {
  position: relative;
}
::v-deep .el-tabs__nav-scroll {
  padding: 0;
  padding-bottom: 20px;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0;
}
::v-deep .el-tabs__item {
  border: 0 !important;
  color: rgba($--color-text-primary, 0.7);
  min-width: 120px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  $rw: 8px;
  $rc: rgba(#fff, 0.8);

  &.is-active {
    border-radius: 17px 17px 0 0;
    background: $rc;
    color: $--color-text-primary;
    &:before {
      content: "";
      position: absolute;
      left: -$rw;
      bottom: 0;
      height: $rw;
      width: $rw;
      // border-radius: 10em;
      // box-shadow: $rw $rw 0 $rw/4 #fff;
      background: radial-gradient(
        at 0% 0%,
        transparent $rw,
        $rc ($rw),
        $rc 100%
      );
    }
    &:after {
      content: "";
      position: absolute;
      right: -$rw;
      bottom: 0;
      height: $rw;
      width: $rw;
      // border-radius: 10em;
      // box-shadow: $rw $rw 0 $rw/4 #fff;
      background: radial-gradient(
        at 100% 0%,
        transparent $rw,
        $rc ($rw),
        $rc 100%
      );
    }
  }
}

::v-deep .el-tabs__nav-scroll:first-child .el-tabs__item:first-child.is-active {
  &:before {
    content: "";
    position: absolute;
    left: 0;
    bottom: -20px;
    height: 20px;
    width: 20px;
    // background: $rc;
    background: radial-gradient(
      at 100% 100%,
      transparent 20px,
      rgba(#fff, 0.8) 20px,
      rgba(#fff, 0.8) 100%
    );
  }
}

::v-deep .el-tabs__header {
  margin-bottom: 0;
  border: 0;
  background: rgba(#000, 0.02);
  border-radius: 17px 0 0 0;
  // padding-right: 260px;
}
::v-deep .el-tabs__nav-wrap {
  margin-bottom: -20px;
}
::v-deep .el-tabs__nav-next,
::v-deep .el-tabs__nav-prev {
  line-height: 34px;
  top: 0;
}

.updateTime {
  position: absolute;
  right: 20px;
  top: 11px;
  font-size: 12px;
  color: $--color-text-secondary;
  padding-left: 1em;
  line-height: 1;
  border-left: 1px solid rgba(#000, 0.08);
  + .el-tabs ::v-deep .el-tabs__header {
    padding-right: 260px;
  }
}
</style>
